const cachable_path = (path: string) => {
  if (!localStorage.getItem('token')) {
    return "/cachable" + path;
  }
  return path;
}

export default cachable_path;